import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=26ecb540"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=26ecb540&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports